module.exports = {"140522100":"凤城镇","140522101":"北留镇","140522102":"润城镇","140522103":"町店镇","140522104":"芹池镇","140522105":"次营镇","140522106":"横河镇","140522107":"河北镇","140522108":"蟒河镇","140522109":"东冶镇","140522110":"演礼镇","140522111":"白桑镇","140522201":"寺头乡","140522202":"西河乡","140522205":"董封乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140522.json
// module id = 397
// module chunks = 0